// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import store from './store/store';
import theme from './theme';
import GlobalStyles from '@mui/material/GlobalStyles';
import { tokenCss } from './styles/palette';
import { setupInterceptors } from './api/apiClient';

// Import CSS for DWLF components
import '@andywilliams/dwlf-charting/styles';

setupInterceptors(store);

const container = document.getElementById('root');
const root = createRoot(container); // Create the root using the container

root.render(
    <Provider store={store}>
        <ThemeProvider theme={theme} modeStorageKey="dwlf-theme" colorSchemeStorageKey="dwlf-color-scheme" defaultMode="system">
            <GlobalStyles styles={tokenCss} />
            <CssBaseline /> {/* Ensures a consistent baseline */}
            <App />
        </ThemeProvider>
    </Provider>
);